export const logInDev = (message: any) => {
  // if (['develop', 'nextrc', 'dev', 'local'].includes(EnvConfiguration.environment)) {
  // eslint-disable-next-line no-underscore-dangle
  if (process.env.__DEV__) {
    // eslint-disable-next-line no-console
    console.log(message);
  }
};
